export default "__VITE_PUBLIC_ASSET__95f42944__"